import { DocumentDetails } from './view';

export { default as DocumentDetailsSaga } from './saga';
export { default as DocumentDetailsReducer } from './reducer';

export default DocumentDetails;
